import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams, Link } from 'react-router-dom';
import { managementAPI } from '../services/api.ts';
import { format } from 'date-fns';

interface HistoryItem {
  id: string;
  date: string;
  time: string;
  location: string;
  address: string;
  projectName?: string;
}

const ManagerHistory: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const loginId = searchParams.get('loginId') || '';
  const start = searchParams.get('start') || '';
  const end = searchParams.get('end') || '';

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [items, setItems] = useState<HistoryItem[]>([]);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      setError(null);
      const params = {
        PageNumber: 1,
        PageSize: 50,
        StartDate: start,
        EndDate: end,
        WorkFlowStatusId: 2,
        ManagerId: loginId
      } as any;
      const response = await managementAPI.getHistory(params);
      const list = Array.isArray(response?.data) ? response.data : response;
      const mapped: HistoryItem[] = (Array.isArray(list) ? list : []).map((x: any) => ({
        id: String(x.id ?? x.Id ?? ''),
        date: x.date || '',
        time: x.time || '',
        location: x.location || x.projectName || 'Unknown Location',
        address: x.address || '',
        projectName: x.projectName
      }));
      setItems(mapped);
    } catch (e: any) {
      setError(e.message || 'Failed to load history');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <div className="container-app py-6">
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b">
          <h2 className="text-lg font-bold">Completed Jobs</h2>
          <p className="text-xs text-gray-500">Login ID: {loginId} • From {start} to {end}</p>
        </div>
        {loading ? (
          <div className="p-6 flex justify-center items-center" style={{ minHeight: 96 }}>
            <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full"></div>
          </div>
        ) : error ? (
          <div className="p-4 text-red-600">{error}</div>
        ) : items.length === 0 ? (
          <div className="p-6 text-center text-gray-500">No completed jobs in this range.</div>
        ) : (
          <div className="divide-y">
            {items.map(item => (
              <Link key={item.id} to={`/schedule/${item.id}`} className="block p-4 hover:bg-gray-50">
                <div className="flex items-center mb-2">
                  <div className="bg-green-500 text-white p-1 rounded mr-2">
                    <span className="text-xs font-bold">{new Date(item.date).toLocaleDateString('en-MY', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                  </div>
                  <span className="text-sm text-gray-600">{item.time}</span>
                </div>
                <div className="text-sm text-gray-800 font-medium">{item.location}</div>
                {item.address && (
                  <div className="text-xs text-gray-600">{item.address}</div>
                )}
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ManagerHistory;


